require('./bootstrap');

// Import modules...
import {computed, createApp, h} from 'vue';
import {App as InertiaApp, plugin as InertiaPlugin, usePage} from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';

const el = document.getElementById('app');

const app = createApp({
    render: () =>
        h(InertiaApp, {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: (name) => require(`./Pages/${name}`).default,
        }),
})
    .mixin({
        methods: {
            route,
            __(key, remplacements) {
                if(!key)
                    return '';

                if(!usePage().props.value.traductions)
                    return key;

                const traductions = computed(() => usePage().props.value.traductions).value;

                if(!(key.toString().toLowerCase() in traductions))
                    return key;

                let traduction = traductions[key.toString().toLowerCase()];

                if(!remplacements || remplacements.length === 0)
                    return traduction;

                for(let key in remplacements) {
                    if(remplacements[key].hasOwnProperty('value') && remplacements[key].hasOwnProperty('key')) {
                        let regex = new RegExp('{'+remplacements[key].key.toUpperCase()+'}', "gi");
                        traduction = traduction.replace(regex, remplacements[key].value);
                    }
                }

                return traduction;
            },
            asset(path) {
                let base_path = window._asset || '/';
                return base_path + path;
            },
        }
    })
    .use(InertiaPlugin)
    .mount(el);

InertiaProgress.init({ color: '#003768'});
